export const RQ_GET_DOCTOR_VISIT_SUMMERY_API = {
  url:'reports/web/effort/doctorVisitSummary/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?entityTagId=<%= entityTagId %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_NEW_DOCTOR_VISIT_SUMMERY_API = {
  url:'reports/web/effort/newDoctorVisitSummary/<%= locationId %>/<%= fromYearMonthDate %>/<%= toYearMonthDate %>?entityTagId=<%= entityTagId %>',
  method:'GET',
  auth:true,
};
